import { LetterRequestCustomer_ScheduleTable_Co_Interface } from './LetterRequestCustomer_ScheduleTable_Co_Interface';

export interface LetterRequestCustomer_ScheduleTable_Interface {
  persianDate:string,
  persianDate_Ful:string,
  offDay:boolean,
  canProgamming:boolean,
  canlender:boolean,
  detail:Array<LetterRequestCustomer_ScheduleTable_Co_Interface>
}

export function Empty_LetterRequestCustomer_ScheduleTable_Interface():LetterRequestCustomer_ScheduleTable_Interface{
  return{
    persianDate:'',
    persianDate_Ful:'',
    offDay:false,
    canlender:false,
    canProgamming:false,
    detail:[],
  }
}
